import { connect } from 'react-redux';
import type { AppState } from 'src/reducers';
import { Footer } from 'src/pages/NavigationShell/Footer/Footer';

function mapStateToProps(state: AppState) {
  const footerTypes = state.appConfig.tenantConfig.footerTypes;

  return {
    footerTypes: footerTypes ?? {},
  };
}

export default connect(mapStateToProps)(Footer);
